export default "__VITE_ASSET__2ILyEbg1__"